import React from "react";
import style from "./index.module.scss";
import { Button, Icon } from "antd";

interface EmptyProps {
    onClick: () => void;
}

export default function Empty({ onClick }: EmptyProps) {
    return (
        <div className={style.root}>
            <img src={require("./img/bg.png")} className={style.img} />

            <div className={style.tip}>暂无消息</div>

            <Button
                type="primary"
                size="large"
                className={style.button}
                onClick={onClick}>
                <Icon type="plus" /> 创建通知
            </Button>
        </div>
    );
}
